export {
  mountAccordions,
  setupArticlePage,
} from './article/index.ts'
export { setupOutline } from './outline/index.ts'
